/**
 * Removes angle brackets from a given value, if they exist at the start and end.
 * @param value - string value from which angle brackets should be removed
 * @returns value without angle brackets, or original value if there are no angle brackets
 */
const removeAngleBrackets = (value: string) => {
  if (typeof value !== "string") return value; // value is sometimes "true" boolean :|

  return value.startsWith("<") && value.endsWith(">")
    ? value.slice(1, -1)
    : value;
};

export default removeAngleBrackets;
